import styled, { css } from "styled-components";
import { PillButton } from "../../../../../../CommonComponents/commonStyles";

export const SelectComponentWrap = styled.div`
  .ant-form-item-control {
    line-height: unset;
  }
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

export const PillButtonGreen = styled(PillButton)`
  background-color: #006778;
  color: #ffffff;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  &:hover,
  &:focus {
    color: #ffffff;
    border-color: #d4d4d4;
    background-color: #006778;
  }
`;

export const PillButtonGreenWrap = styled.div`
  button {
    width: 170px;
    height: 30px !important;
  }
  margin: 34px 0 20px 0;
`;

export const PillButtonAddSpace = styled.div`
  margin-top: 16px;
  margin-bottom: 50px;
`;

export const PillButtonAddSpaceAdd = styled(PillButtonAddSpace)`
  margin-bottom: 18px;
  margin-top: 0;
`;

export const TabsWrapper = styled.div`
  .ant-tabs{
    overflow:unset;
  }
  .ant-tabs-tab {
    margin: 0 !important;
    height: 56px !important;
    border-radius: 0 !important;
    background: #f4f3f3 !important;
    border-top: 4px solid rgba(0, 103, 120, 0.1) !important;
    border-bottom: 1px solid #d4d4d4 !important;
    border-left: 1px solid #d4d4d4 !important;
    .ant-tabs-tab-active ~ :nth-child(${ props => props.tabActiveKey}) { 
      border: none;
    }
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  height: 56px !important;
  border-right-width: inherit;
  &:last-child {
    border-right: 1px solid #d4d4d4 !important;
  }
  border-left: 1px solid #d4d4d4 !important;
    line-height: 30px;
  }

  .ant-tabs-nav-container {
    height: 55px !important;
  }

  .ant-tabs-bar {
    border-bottom: 1px solid #d4d4d4;
  }
  .ant-tabs-tab-active {
    border-color: #d4d4d4 !important;
    border-top: 4px solid #006778 !important;
    border-bottom: none !important;
    border-left: 1px solid #d4d4d4 !important;
    background-color: #ffffff !important;
  }
  .ant-tabs-ink-bar {
    height: 1px;
    background-color: #d4d4d4;
  }

  .ant-tabs-tab-prev,
  .ant-tabs-tab-next {
    display: block;
  }
  .ant-tabs-tab-btn-disabled {
    cursor: pointer;
  }

  .ant-tabs-tab-prev {
    left: -10px;
  }

  .ant-tabs-tab-next {
    right: -10px;
  }
`;

export const TitleWrap = styled.div`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  letter-spacing: 0.6px;
  color: #006778;
  padding: 4px 4px 4px 4px;
`;

export const Err = styled.div`
  margin-top: 15px;
  ${fontCommonStyle}
  color: ${props => props.theme.fontColors.error};
  line-height: 1.25;
  letter-spacing: 0.6px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;